'use client'

import { useState } from 'react'
import Image from 'next/image'
import { X } from 'lucide-react'

export type MasonryGalleryProps = {
  images: Array<{ url: string; alt?: string }>
  columns?: 2 | 3 | 4
}

const colClasses = {
  2: 'columns-1 sm:columns-2',
  3: 'columns-1 sm:columns-2 lg:columns-3',
  4: 'columns-1 sm:columns-2 lg:columns-4',
} as const

export function MasonryGallery({ images, columns = 3 }: MasonryGalleryProps) {
  const [lightbox, setLightbox] = useState<number | null>(null)

  return (
    <>
      <div className={`${colClasses[columns]} gap-4 px-[var(--section-padding-x,1rem)] max-w-[var(--section-max-width,var(--max-width-page))] mx-auto`} data-component="MasonryGallery">
        {images.map((img, i) => (
          <button
            key={i}
            onClick={() => setLightbox(i)}
            className="block w-full mb-4 break-inside-avoid rounded-[var(--radius-lg)] overflow-hidden hover:opacity-90 transition-opacity"
          >
            <Image
              src={img.url}
              alt={img.alt ?? ''}
              width={600}
              height={400}
              className="w-full h-auto object-cover"
              sizes="(max-width: 640px) 100vw, (max-width: 1024px) 50vw, 33vw"
            />
          </button>
        ))}
      </div>

      {lightbox !== null && (
        <div className="fixed inset-0 z-50 bg-black/80 flex items-center justify-center p-4" onClick={() => setLightbox(null)}>
          <button onClick={() => setLightbox(null)} className="absolute top-4 right-4 text-white" aria-label="Close">
            <X className="w-6 h-6" />
          </button>
          <Image
            src={images[lightbox].url}
            alt={images[lightbox].alt ?? ''}
            width={1200}
            height={800}
            className="max-w-full max-h-[85vh] object-contain rounded-lg"
            onClick={(e) => e.stopPropagation()}
          />
        </div>
      )}
    </>
  )
}
